import { createFileRoute } from '@tanstack/react-router'

import { CheckoutPage } from '~/boundedContext/subscription/pages/checkout-page'

import { checkoutSearchSchema } from './-schemas/search-schema'

export const Route = createFileRoute('/subscription/checkout/')({
  component: CheckoutPage,
  validateSearch: search => checkoutSearchSchema.parse(search),
})
